<header *ngIf="consultant$ | async as consultant">
  <nav class="navbar p-0 mb-5" *ngIf="consultant">
    <div class="container">
      <div class="col-8 col-lg-9 text-left pl-0">
        <div class="d-table-cell logo">
          <a class="mx-3" routerLink="/">
            <img src="/favicon.png" alt="Randstad">
          </a>
        </div>

        <div class="d-table-cell menu-wrapper">
          <span class="title">{{title}}</span>
          <ul class="menu pl-0">
            <li class="nav-item">
              <a class="nav-link" routerLink="consultant/candidates" routerLinkActive="active">{{ 'COMMON.CANDIDATES' | translate }}</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" routerLink="consultant/boarding" routerLinkActive="active">{{ 'COMMON.TESTS' | translate }}</a>
            </li> -->

            <div ngbDropdown class="d-inline-block main-menu">
              <button class="p-0 border-0" id="dropdownBasic1" ngbDropdownToggle>{{ 'COMMON.TESTS' | translate }}</button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem routerLink="consultant/tests" routerLinkActive="active">{{'CONSULTANT.TESTSEARCH' | translate}}</button>
                <button ngbDropdownItem routerLink="consultant/profiles" routerLinkActive="active">{{'IDEALPROFILE.TITLE' | translate}}</button>
                <button ngbDropdownItem routerLink="consultant/processes" routerLinkActive="active">{{'COMMON.PROCESSES' | translate}}</button>
              </div>
            </div>

          </ul>
        </div>
      </div>

      <div class="col-4 col-lg-3 text-right profile-menu" *ngIf="consultant$ | async as consultant">
        <div ngbDropdown class="d-inline-block">
          <button class="p-0 border-0 profile-menu-dropdown" ngbDropdownToggle>
            <img *ngIf="consultant.profilePicture" alt="Foto perfil" class="profile-picture" [src]="consultant.profilePicture">
            <i *ngIf="!consultant.profilePicture" class="fa fa-user fa-2x profile-picture"></i>
          </button>
          <div ngbDropdownMenu class="dropdown-menu-right">
            <button ngbDropdownItem (click)="authenticationService.logOut('consultant');$event.stopPropagation();">{{ 'LOGIN.LOGOUT' | translate }}</button>
          </div>
        </div>

        <div class="office-wrapper">
          <div *ngIf="consultant.client.id == 1">
            <i class="fa fa-life-ring" [title]="'COMMON.HELP' | translate"></i>
            <span><a href="http://fbicentrosoporte.randstad.es/4hg3j4u0rvpshzj7atlyg0694tcrjvtn" target="_blank" rel="noopener noreferrer"> {{ 'COMMON.HELP' | translate }}</a></span>
          </div>
          <div (click)="consultant.client.id == 1? officeSelector.open() : ''">
            <i class="eye" [title]="'COMMON.OFFICE' | translate"></i>
            <span>{{ consultant.office?.name | titlecase }}</span>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>

<ct-office-selector></ct-office-selector>
